<template>
	<div>
		<div class="linkWrapper filter">
			<span class="titleItem" @click="open=!open">By Product</span>
			<span 
				class="hasChildren"
				:class="open ? 'showChildren' : ''"
				@click="open=!open"
			></span>
		</div>

		<ul 
			v-if="this.$route.name == 'search' || refineOptions.length > 0" 
			class="tickFilters subcategoryList" 
			ref="subList"
			:style="'max-height: ' + maxHeight + 'px;'"
		>
			<!-- TODO in search how do -->
			<div v-if="this.$route.name == 'search'">
				<!-- When in search results, show hierarchy of filters since products can be from multiple categories -->
				<div v-for="level0 in categoriesTree" :key="level0.cat.id">
					<TickFilter
						:onclick="() => {refineClick(level0.cat.id)}"
						:ticked="selectedRefines.includes(level0.cat.id)"
						class="level0"
					>
						{{level0.cat.category}}
					</TickFilter>

					<div v-for="level1 in level0.children" :key="level1.cat.id">
						<TickFilter
							:onclick="() => {refineClick(level1.cat.id)}"
							:ticked="selectedRefines.includes(level1.cat.id)"
							class="level1"
						>
							{{level1.cat.category}}
						</TickFilter>

						<div v-for="level2 in level1.children" :key="level2.cat.id">
							<TickFilter
								:onclick="() => {refineClick(level2.cat.id)}"
								:ticked="selectedRefines.includes(level2.cat.id)"
								class="level2"
							>
								{{level2.cat.category}}
							</TickFilter>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<!-- Just display list of filters when in category -->
				<TickFilter
					v-for="refine in refineOptions"
					:key="refine.id"
					:onclick="() => {refineClick(refine.id)}"
					:ticked="selectedRefines.includes(refine.id)"
				>
					{{refine.category}}
				</TickFilter>
			</div>
		</ul>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import TickFilter from "@/components/filters/tickFilter";

export default {
	name: "SubSubCategoryFilter",
	props: ["products", "allProducts", "startOpen"],
	components: {
		TickFilter
	},
	data(){
		return {
			open: false,
		}
	},
	created(){
		//ensure that category names have been fetched
		this.$store.dispatch("reference/getReference");
		
	},
	mounted() {
		if (this.startOpen != undefined) {
			// this.open = this.startOpen;

		}
	},
	methods: {
		refineClick(refineId) {
			var newQuery;
			if (this.$route.query.refine) {
				newQuery = this.$route.query.refine.split(",");
			} else {
				newQuery = [];
			}

			if (newQuery.includes(refineId)) {
				//item in refines, remove from it
				newQuery = newQuery.filter(item => item != refineId);
			} else {
				//add id to refine array
				newQuery.push(refineId);
			}
			var newQueryString = newQuery.join(",");
			if (newQueryString != "") {
				this.$router.replace({
				query: { ...this.$route.query, refine: newQueryString }
				});
			} else {
				this.$router.replace({
				query: { ...this.$route.query, refine: undefined }
				}); //unset refineId
			}
		}
	},
	computed: {
		...mapState({
		// map categories to store.reference.categories
			categories: state => state.reference.categories
		}),
		...mapGetters("reference", ["categoriesMap"]),
		refineOptions() {
			if (
				this.categories &&
				this.$route.params.category &&
				this.$route.params.subcategory
			) {
				const category = this.categories[this.$route.params.category];
				const subcategory = category.children[this.$route.params.subcategory];
				const refineOptions = subcategory.children;

				let sorted = Object.values(refineOptions).sort((a,b) => a.category.localeCompare(b.category))

				return sorted;
			} else {
				return this.categoriesInResults;
			}
		},
		categoriesInResults() {
			if (!this.allProducts || this.allProducts.length === 0) return [];

			let productCategoryIds = new Set();
			this.allProducts.forEach(product => {
				if(Array.isArray(product.categories)){
				product.categories.forEach(categoryId => {
					productCategoryIds.add(parseInt(categoryId));
				});
				}
				// refineMap[product.categories] = product.brand
			});

			productCategoryIds = Array.from(productCategoryIds);

			let categories = productCategoryIds
				.map(categoryId => {
				return this.categoriesMap[categoryId];
				})
				.filter(item => item != undefined)
				.sort((a,b) => (a.category.localeCompare(b.category)))

			return categories;
		},
		categoriesTree() {
			let l0 = this.categoriesInResults.filter(item => item.level == 0);
			let l1 = this.categoriesInResults.filter(item => item.level == 1);
			let l2 = this.categoriesInResults.filter(item => item.level == 2);

			let result = l0.map(category => {
				let l0Children = l1
				.filter(item => item.parent == category.id)

				.map(subcategory => {
					let l1Children = l2
					.filter(item2 => item2.parent == subcategory.id)
					.map(subsubcat => {
						return { cat: subsubcat, children: [] };
					});
					return { cat: subcategory, children: l1Children };
				});
				return { cat: category, children: l0Children };
			});


			return result;
		},
		selectedRefines() {
			if (this.$route.query.refine) {
				return this.$route.query.refine.split(",");
			} else {
				return [];
			}
		},
		height() {
			let height = 0;
			if("subList" in this.$refs) {
				for (let child of this.$refs.subList.children){
					height += child.offsetHeight;
				}
			}
			return height;
		},
		maxHeight() {
			if (this.open) {
				return this.height;
			} else {
				return 0;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
	// Styles are in the main style sheet since this is reused
	.tickFilters {
		list-style-type: none;
	}

	.level0 {
		font-size: 1.2em;
		font-weight: bold;
	}
	.level1 {
		font-size: 1em;
		margin-left: 5px;
	}

	.level2 {
		font-size: 0.8em;
		margin-left: 10px;
		font-weight: lighter;
	}
</style>
